export default __webpack_public_path__ + "static/media/ForgetPasswordBg.31b41697.svg";